const options = JSON.parse(`{"namespace":"fathom","spa":"history","siteId":"NZLJQBLI"}`)
const { debug, namespace } = options

if (debug) {
  console.log(`DEBUG ENABLED - ${namespace} options: `, options)
}